<!---消费规则设置--->
<template>
  <div>
    <div class="rule-item" v-for="(i,key) in data" :key="key">
      <div class="label">{{i.Text}}</div>
      <div class="value">
        <span style="margin-right: 10px;">余额不足</span>
        <el-input v-model="i.Value" v-num placeholder="请输入金额"></el-input>
        <span style="margin-left: 10px;">元时提醒</span>
      </div>
    </div>
    <el-divider></el-divider>
    <div style="text-align: right;">
      <el-button :loading="isLoading" type="primary" @click="save">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      api: require("@/api/cp/setting").default,
      data: [],
      isLoading: false,
    };
  },
  mounted() {
    this.api.list({}).then((res) => {
      console.log("res", res);
      this.data = res.Data;
    });
  },
  methods: {
    save() {
      this.isLoading = true;
      this.api.save(this.data).then((res) => {
        this.isLoading = false;
        if (res.Code == 0) {
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.rule-item {
  display: flex;
  font-size: 16px;
  color: #303133;
  line-height: 40px;
  .label {
    width: 160px;
    margin-right: 15px;
  }
  .value {
    width: calc(100% - 100px);
    .el-input {
      width: 140px;
      .el-input__inner {
        border: none;
        border-bottom: 1px solid #dcdfe6;
        border-radius: 0px;
      }
    }
  }
}
</style>